import whatsappUrl  from '../assets/channel-icons/whatsapp.svg';
import facebookUrl  from '../assets/channel-icons/facebook.svg';
import messengerUrl from '../assets/channel-icons/messenger.svg';
import instagramUrl from '../assets/channel-icons/instagram.svg';
import telegramUrl  from '../assets/channel-icons/telegram.svg';
import emailUrl     from '../assets/channel-icons/email.svg';
import webchatUrl   from '../assets/channel-icons/webchat.svg';
import wordpressUrl from '../assets/channel-icons/wordpress.svg';
import tiktokUrl    from '../assets/channel-icons/tiktok.svg';

const SOURCES = {
  whatsapp:  { url: whatsappUrl,  alt: 'WhatsApp' },
  facebook:  { url: facebookUrl,  alt: 'Facebook' },
  messenger: { url: messengerUrl, alt: 'Messenger' },
  instagram: { url: instagramUrl, alt: 'Instagram' },
  telegram:  { url: telegramUrl,  alt: 'Telegram' },
  email:     { url: emailUrl,     alt: 'Email' },
  webchat:   { url: webchatUrl,   alt: 'Web Chat' },
  wordpress: { url: wordpressUrl, alt: 'WordPress' },
  tiktok:    { url: tiktokUrl,    alt: 'TikTok' },
  tiktok_shop: { url: tiktokUrl,  alt: 'TikTok Shop' },
};

export default function ChannelIcon({ channel, size = 20, className, style }) {
  const key = String(channel || '').toLowerCase();
  const src = SOURCES[key];
  if (!src) return null;
  return (
    <img
      src={src.url}
      alt={src.alt}
      width={size}
      height={size}
      className={className}
      style={style}
      draggable={false}
    />
  );
}
